import React, { ReactNode } from 'react';
import Text from '@/components/marketing/Text';
import Section from '@/components/marketing/Section';

interface CustomerQuoteProps {
  children?: ReactNode;
  image?: string;
  name?: string;
  position?: string;
}

const CustomerQuote: React.FC<CustomerQuoteProps> = ({
  children,
  image = '',
  name = '',
  position = '',
}) => {
  return (
    <Section
      contentWidth="content-xs"
      padding="p-none"
      className="mx-auto my-4 overflow-hidden relative group"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-slate-50"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-white/0 via-white/5 to-white/20 opacity-0 transition-opacity duration-700"></div>

      <Section contentWidth="content-xxs" className="relative z-10">
        <div className="flex flex-col items-center gap-4 p-1 md:p-2">
          <div className="relative">
            <div className="w-16 h-16 md:w-20 md:h-20 overflow-hidden rounded-full bg-white shadow-lg ring-4 ring-white/50 transition-all duration-300">
              <img
                src={image}
                alt={`Portrait of ${name}`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -inset-0.5 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full blur opacity-0 transition-opacity duration-700"></div>
          </div>

          <Text
            as="blockquote"
            size="xl"
            align="center"
            tracking="tight"
            color="primary"
            className="relative leading-relaxed"
          >
            {children}
          </Text>

          <div className="flex flex-col items-center gap-1">
            <Text
              as="span"
              weight="semibold"
              color="primary"
              size="lg"
            >
              {name}
            </Text>
            <Text
              size="sm"
              color="secondary"
            >
              {position}
            </Text>
          </div>
        </div>
      </Section>

      <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-blue-100/30 to-transparent opacity-0 transition-opacity duration-700"></div>
      <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-purple-100/30 to-transparent opacity-0 transition-opacity duration-700"></div>
    </Section>
  );
};

export default CustomerQuote;